"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.PadDirection = void 0;
const tslib_1 = require("tslib");
const _ = tslib_1.__importStar(require("underscore"));
const rx_utils_1 = require("./rx-utils");
var PadDirection;
(function (PadDirection) {
    PadDirection[PadDirection["RIGHT"] = 0] = "RIGHT";
    PadDirection[PadDirection["LEFT"] = 1] = "LEFT";
})(PadDirection = exports.PadDirection || (exports.PadDirection = {}));
/**
 * !!!!!!!!!!!!!!!!!!!! WARNING !!!!!!!!!!!!!!!!!!!!
 * Please do not add any more methods to this class. Since static util classes aren't tree-shakeable, we should rather provide single exported functions, like in ./rx-utils.ts
 */
class Utils {
    /**
     * @deprecated use clone from common-utils.ts directly (for better tree-shakeability)
     */
    static clone(obj) {
        if (obj !== undefined && obj !== null)
            return JSON.parse(JSON.stringify(obj));
        return obj;
    }
    static equals(objA, objB) {
        if (typeof objA === "undefined" || typeof objB !== typeof objA)
            return false;
        return JSON.stringify(objA) === JSON.stringify(objB);
    }
    static isNonEmptyString(str) {
        return _.isString(str) && !_.isUndefined(str) && !_.isEmpty(str) && str !== null && str !== undefined;
    }
    static isEmptyString(str) {
        return !Utils.isNonEmptyString(str);
    }
    static stringEndsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }
    static dasherize(str) {
        return str.replace(/[A-Z]/g, (char, index) => {
            return (index !== 0 ? "-" : "") + char.toLowerCase();
        });
    }
    static decapitalize(str) {
        return typeof str === "string" ? str.charAt(0).toLowerCase() + str.slice(1) : str;
    }
    static capitalize(str) {
        return typeof str === "string" ? str.charAt(0).toUpperCase() + str.slice(1) : str;
    }
    // public static spaceBeforeUppercase(str: string): string {
    //     return str.replace(/([A-Z])/g, " $1").trim();
    // }
    static padString(str, maxLength, direction = PadDirection.LEFT, fillingCharacter = " ") {
        if (typeof str !== "string")
            throw new Error("first argument of padString has to be typeof string!");
        const padlen = maxLength - str.length;
        switch (direction) {
            case PadDirection.RIGHT:
                for (let i = 0; i < padlen; i++) {
                    str = str + fillingCharacter;
                }
                return str;
            default:
                for (let i = 0; i < padlen; i++) {
                    str = fillingCharacter + str;
                }
                return str;
        }
    }
    static isMobile() {
        // tslint:disable-next-line:no-string-literal
        const userAgent = navigator.userAgent || navigator.vendor || window["opera"];
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(userAgent.substr(0, 4)))
            return true;
        return false;
    }
    static getUrlParameterByName(name, url) {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
        const results = regex.exec(url);
        return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    static createUrlConformIdFromInput(input, maxLength) {
        if (input === undefined)
            return "";
        // umlauts
        input = input.replace(/[üÜ]/g, "ue");
        input = input.replace(/[äÄ]/g, "ae");
        input = input.replace(/[öÖ]/g, "oe");
        input = input.replace(/[ß]/g, "ss");
        // spaces
        input = input.replace(/ /g, "_");
        input = input.replace(/[^a-zA-Z0-9_-]/g, "").toLowerCase();
        if (maxLength)
            return input.substring(0, maxLength);
        return input;
    }
    /** @deprecated use unflattenJson directly */
    static unflattenJSON(data) {
        if (Object(data) !== data || Array.isArray(data))
            return data;
        const regex = /\.?([^.[\]]+)|\[(\d+)\]/g;
        const resultholder = {};
        for (const p in data) {
            if (data.hasOwnProperty(p)) {
                let cur = resultholder;
                let prop = "";
                let m;
                // eslint-disable-next-line no-cond-assign
                while ((m = regex.exec(p))) {
                    cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
                    prop = m[2] || m[1];
                }
                cur[prop] = data[p];
            }
        }
        return resultholder[""] || resultholder;
    }
    /** @deprecated use flattenJson directly */
    static flattenJSON(data, flattenArrays = true) {
        const result = {};
        function recurse(current, prop) {
            if (Object(current) !== current) {
                result[prop] = current;
            }
            else if (Array.isArray(current)) {
                if (flattenArrays) {
                    for (let i = 0, l = current.length; i < l; i++)
                        recurse(current[i], `${prop}[${i}]`);
                    if (current.length === 0)
                        result[prop] = [];
                }
                else {
                    result[prop] = current;
                }
            }
            else {
                let isEmpty = true;
                for (const p in current) {
                    if (current.hasOwnProperty(p)) {
                        isEmpty = false;
                        recurse(current[p], prop ? `${prop}.${p}` : p);
                    }
                }
                if (isEmpty && prop)
                    result[prop] = {};
            }
        }
        recurse(data, "");
        return result;
    }
    static prettyPrintJson(object, maxLength) {
        if (object === undefined)
            return "-";
        let str = object;
        if (_.isObject(object)) {
            str = JSON.stringify(object, undefined, 4);
        }
        if (maxLength && str.length > maxLength)
            return str.substring(0, maxLength - 6) + " (...)";
        return str;
    }
    static convertHexToRGB(colorAsHex) {
        colorAsHex = colorAsHex.replace("#", "");
        if (colorAsHex.length !== 6)
            throw new Error("Please provide hex colors in 6-digit format!");
        const r = parseInt(colorAsHex.substring(0, 2), 16);
        const g = parseInt(colorAsHex.substring(2, 4), 16);
        const b = parseInt(colorAsHex.substring(4, 6), 16);
        return { r, g, b };
    }
    static toHex(c) {
        const hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    static convertRGBToHex(r, g, b) {
        return "#" + Utils.toHex(r) + Utils.toHex(g) + Utils.toHex(b);
    }
    // rgb(69, 90, 100)
    static convertRGBStringToHex(rgb) {
        const regexArray = /rgb\(([0-9]{1,3}),([0-9]{1,3}),([0-9]{1,3})\)/.exec(rgb.replace(/ /g, ""));
        if (regexArray)
            return ("#" +
                Utils.toHex(parseInt(regexArray[1])) +
                Utils.toHex(parseInt(regexArray[2])) +
                Utils.toHex(parseInt(regexArray[3])));
    }
    // from https://css-tricks.com/converting-color-spaces-in-javascript/
    static convertHexToHsl(hex) {
        // Convert hex to RGB first
        let r = 0, g = 0, b = 0;
        if (hex.length == 4) {
            r = parseInt("0x" + hex[1] + hex[1]);
            g = parseInt("0x" + hex[2] + hex[2]);
            b = parseInt("0x" + hex[3] + hex[3]);
        }
        else if (hex.length == 7) {
            r = parseInt("0x" + hex[1] + hex[2]);
            g = parseInt("0x" + hex[3] + hex[4]);
            b = parseInt("0x" + hex[5] + hex[6]);
        }
        else
            throw Error("Either provide hex color as 4 or as 7 chars: #FFF or #FFFFFF");
        // Then to HSL
        r /= 255;
        g /= 255;
        b /= 255;
        const cmin = Math.min(r, g, b);
        const cmax = Math.max(r, g, b);
        const delta = cmax - cmin;
        let h = 0, s = 0, l = 0;
        if (delta == 0)
            h = 0;
        else if (cmax == r)
            h = ((g - b) / delta) % 6;
        else if (cmax == g)
            h = (b - r) / delta + 2;
        else
            h = (r - g) / delta + 4;
        h = Math.round(h * 60);
        if (h < 0)
            h += 360;
        l = (cmax + cmin) / 2;
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);
        return { h, s, l };
    }
    // public static isValidUrlName(url: string): boolean {
    //     return /\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b/.test(url);
    // }
    static dataURLtoBlob(dataurl) {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }
    static blobToDataURL(blob, callback) {
        const a = new FileReader();
        a.onload = (e) => {
            callback(e.target.result);
        };
        a.readAsDataURL(blob);
    }
    static blobToArrayBuffer(blob, callback) {
        const fileReader = new FileReader();
        fileReader.onload = function () {
            callback(this.result);
        };
        fileReader.readAsArrayBuffer(blob);
    }
    static dataUrlToBuffer(dataUrl, callback) {
        this.blobToArrayBuffer(this.dataURLtoBlob(dataUrl), callback);
    }
    static imageUrlToBlob(url, callback) {
        const image = new Image();
        image.onerror = () => {
            console.error("Utils", "Could not convert url to blob: ", url);
        };
        image.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = this.width;
            canvas.height = this.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0);
            canvas.toBlob((blob) => {
                callback(blob);
            });
        };
        image.src = url;
    }
    static getApiURL(collectionName, queryName) {
        return `${collectionName}/${Utils.decapitalize(queryName.replace("get", "")).toLowerCase()}`;
    }
    // public static objectToURLParams(obj: any, prefix: string = ""): string {
    //     return Object.keys(obj).map((key) => {
    //         return `${prefix}${key}=${encodeURIComponent(obj[key])}`;
    //     }).join("&");
    // }
    /**
     * stringifies any object, can return null and undefined
     *
     * @param value any stringifyable object
     * @param maxLength defaults to 100 characters
     */
    static stringifyValue(value, maxLength = 100) {
        if (value === null || value === undefined)
            return value;
        try {
            return this.truncateString(JSON.stringify(value), maxLength);
        }
        catch (e) {
            return value;
        }
    }
    /**
     * returns a text like "hello hello hi hi (+434 characters)"
     *
     * @param value any stringifyable object
     * @param maxLength defaults to 100 characters
     */
    static truncateString(value, maxLength = 100) {
        if (typeof value !== "string")
            return value;
        try {
            if (value.length > maxLength)
                return `${value.substr(0, maxLength)} (+${value.length - maxLength} more characters)`;
            else
                return value;
        }
        catch (e) {
            return value;
        }
    }
    static isNumberString(s) {
        return typeof s === "string" && s.length && !isNaN(s);
    }
    static isObjectIdString(s) {
        var _a;
        return typeof s === "string" && s.length && ((_a = s.match(/^[0-9a-fA-F]{24}$/)) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }
    static isBooleanString(s) {
        return typeof s === "string" && s.length && (s.toLowerCase() === "true" || s.toLowerCase() === "false");
    }
    static isJsonString(s) {
        if (!s || typeof s !== "string")
            return false;
        try {
            JSON.parse(s);
        }
        catch (e) {
            return false;
        }
        return true;
    }
    static isObject(obj) {
        return typeof obj === "object" && obj !== null && obj.toString() === {}.toString();
    }
    static isArray(obj) {
        return typeof obj === "object" && obj instanceof Array;
    }
    static sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    /**
     * @deprecated use filterNullish from rx-utils.ts directly (for better tree-shakeability)
     * Filters null and undefined values while indicating to TypeScript that these vales are no longer possible.
     */
    static filterNullish() {
        return (0, rx_utils_1.filterNullish)();
    }
    /**
     * @deprecated use removeNullish from rx-utils.ts directly (for better tree-shakeability)
     * Removes null and undefined values recursively from an object
     */
    static removeNullish(obj, options = { removeEmptyStrings: false }) {
        return (0, rx_utils_1.removeNullish)(obj, options);
    }
    /**
     * Map an array exactly like Array.prototype.map(), but async
     */
    static asyncMap(array, callbackFn) {
        return Promise.all(array.map(callbackFn));
    }
    /**
     * Filter an array exactly like Array.prototype.filter(), but async
     */
    static asyncFilter(array, callbackFn) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const filterMap = yield this.asyncMap(array, callbackFn);
            return array.filter((value, index) => filterMap[index]);
        });
    }
    /**
     * Create a string of non-numeric characters. Mapping: `0` -> `a`, `1` -> `b`, etc.
     */
    static numberToNonNumericCharacterString(number) {
        return number
            .toString()
            .split("")
            .map((n) => (Number(n) + 10).toString(36))
            .join("");
    }
    /**
     * Checks if a given array of ObjectIds contains a certain ObjectId.
     */
    static includesObjectId(array, objectId) {
        return array.findIndex((id) => id.equals(objectId)) >= 0;
    }
}
exports.Utils = Utils;
